let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2F0HM")).then(() => parcelRequire('9RMYL'));